import React, { useState, forwardRef, useImperativeHandle } from 'react'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'

const convertDateFormat = (dateString) => {
  const [day, month, year] = dateString.split('.')
  return `${year}-${month}-${day}`
}

const CompetitionDate = forwardRef(
  ({ defaultstartDate = '', defaultendDate = '' }, ref) => {
    const [startDate, setStartDate] = useState(
      convertDateFormat(defaultstartDate)
    )
    const [endDate, setEndDate] = useState(convertDateFormat(defaultendDate))
    const [error, setError] = useState('')

    // Валидация дат

    const val = () => {
      return { startDate, endDate }
    }
    const validate = () => {
      if (startDate.trim() === '' || endDate.trim() === '') {
        setError('Оба поля обязательны для заполнения')
        return false
      }

      if (new Date(endDate) < new Date(startDate)) {
        setError('Дата окончания не может быть раньше даты начала')
        return false
      }

      setError('') // Очищаем ошибку, если валидация прошла успешно
      return true
    }

    // Экспортируем метод validate через ref
    useImperativeHandle(ref, () => ({
      validate,
      val,
    }))

    return (
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <Grid item xs={12} sm={6}>
          <TextField
            id="start_date"
            label="Старт турнира"
            type="date"
            fullWidth
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              '& .MuiInputBase-root': {
                width: '100%',
              },
            }}
            error={!!error}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            id="end_date"
            label="Финиш турнира"
            type="date"
            fullWidth
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              '& .MuiInputBase-root': {
                width: '100%',
              },
            }}
            error={!!error}
          />
        </Grid>
        {error && (
          <Grid item xs={12}>
            <Typography color="error" variant="body2">
              {error}
            </Typography>
          </Grid>
        )}
      </Grid>
    )
  }
)

export default CompetitionDate
